import React from 'react'
import LoadPageFooter from '../load-page/LoadPageFooter'

export default function LoginFooter(props) {
  return (
    <LoadPageFooter />
  )
}
